/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=91c9a23e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=91c9a23e&lang=less"

import exportComponent from "/var/jenkins_home/workspace/yunibao-invite-h5-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__